(function() {
  'use strict';

  function patchEventUtilities() {
    if (!window.theme || !theme.delegate || !theme.utils || theme.__bsignEventUtilitiesPatched) {
      return;
    }

    var passiveEventNames = {
      scroll: true
    };

    function normalizeEventOptions(eventName, options) {
      if (typeof options !== 'undefined' && options !== null) {
        return options;
      }

      if (passiveEventNames[eventName]) {
        return { passive: true };
      }

      return false;
    }

    theme.delegate.on = function(event, callback, options) {
      var eventName = event.split('.')[0];
      var resolvedOptions = normalizeEventOptions(eventName, options);

      if (!this.namespaces) {
        this.namespaces = {};
      }

      this.namespaces[event] = {
        callback: callback,
        options: resolvedOptions
      };

      this.addEventListener(eventName, callback, resolvedOptions);

      return this;
    };

    theme.delegate.off = function(event) {
      if (!this.namespaces || !this.namespaces[event]) {
        return this;
      }

      this.removeEventListener(
        event.split('.')[0],
        this.namespaces[event].callback,
        this.namespaces[event].options
      );

      delete this.namespaces[event];

      return this;
    };

    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    theme.utils.rafThrottle = function(callback) {
      var ticking = false;
      var context;
      var args;

      return function() {
        context = this;
        args = arguments;

        if (ticking) {
          return;
        }

        ticking = true;

        window.requestAnimationFrame(function() {
          ticking = false;
          callback.apply(context, args);
        });
      };
    };

    theme.utils.throttle = function(limit, callback) {
      if (limit <= 20 && typeof window.requestAnimationFrame === 'function') {
        return theme.utils.rafThrottle(callback);
      }

      var waiting = false;

      return function() {
        if (waiting) {
          return;
        }

        callback.apply(this, arguments);
        waiting = true;

        window.setTimeout(function() {
          waiting = false;
        }, limit);
      };
    };

    theme.__bsignEventUtilitiesPatched = true;
  }

  function patchParallax() {
    if (!window.theme || !theme.Parallax || !theme.Parallax.prototype || theme.__bsignParallaxPatched) {
      return;
    }

    var speed = 0.85;
    var reset = false;
    var parallaxPrototype = theme.Parallax.prototype;

    parallaxPrototype.init = function(desktopOnly) {
      if (this.isInit) {
        this.destroy();
      }

      this.isInit = true;
      this.scrollTicking = false;
      this.scrollListener = this.scrollListener || this.onScroll.bind(this);
      this.resizeListener = this.resizeListener || theme.utils.debounce(250, this.setSizes.bind(this));
      this.reorderListener = this.reorderListener || theme.utils.debounce(250, this.onReorder.bind(this));

      if (desktopOnly && theme.config.bpSmall) {
        return;
      }

      this.setSizes();
      this.scrollHandler();

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          this.isVisible = entry.isIntersecting;

          if (this.isVisible) {
            window.on('scroll' + this.namespace, this.scrollListener);
          } else {
            window.off('scroll' + this.namespace);
          }
        }.bind(this));
      }.bind(this), { rootMargin: '200px 0px 200px 0px' });

      this.observer.observe(this.container);

      window.off('resize' + this.namespace);
      window.on('resize' + this.namespace, this.resizeListener);

      document.removeEventListener('shopify:section:reorder', this.reorderListener);
      document.addEventListener('shopify:section:reorder', this.reorderListener);
    };

    parallaxPrototype.onScroll = function() {
      if (!this.isVisible) {
        return;
      }

      if (window.SPR && !reset) {
        this.setSizes();
        reset = true;
      }

      if (this.scrollTicking) {
        return;
      }

      this.scrollTicking = true;

      window.requestAnimationFrame(function() {
        this.scrollTicking = false;
        this.scrollHandler();
      }.bind(this));
    };

    parallaxPrototype.scrollHandler = function() {
      var shiftDistance = (window.scrollY - this.elTop) * speed;
      this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
    };

    parallaxPrototype.destroy = function() {
      if (!this.image) {
        return;
      }

      this.image.style.transform = 'none';
      this.isInit = false;
      this.isVisible = false;
      this.scrollTicking = false;

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      window.off('scroll' + this.namespace);
      window.off('resize' + this.namespace);
      document.removeEventListener('shopify:section:reorder', this.reorderListener);
    };

    theme.__bsignParallaxPatched = true;
  }

  function patchSlideshowResizeCleanup() {
    if (!window.theme || !theme.Slideshow || theme.__bsignSlideshowPatched) {
      return;
    }

    var OriginalSlideshow = theme.Slideshow;
    var originalPrototype = OriginalSlideshow.prototype;
    var originalDestroy = originalPrototype.destroy;
    var slideshowId = 0;

    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false,
      childNav: null,
      childNavScroller: null,
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      setGallerySize: true,
      wrapAround: true
    };

    function avoidReflow(el) {
      var firstChild;
      var style;

      if (!el.id) {
        return;
      }

      firstChild = el.firstChild;
      while (firstChild != null && firstChild.nodeType === 3) {
        firstChild = firstChild.nextSibling;
      }

      if (!firstChild) {
        return;
      }

      style = document.createElement('style');
      style.innerHTML = '#' + el.id + ' .flickity-viewport{height:' + firstChild.offsetHeight + 'px}';
      document.head.appendChild(style);
    }

    function PatchedSlideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
      this.namespace = '.slideshow-' + (++slideshowId);

      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);

        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);

        this.pauseBtn = wrapper ? wrapper.querySelector(selectors.pauseButton) : null;

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      window.on('resize' + this.namespace, theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
    }

    PatchedSlideshow.prototype = originalPrototype;
    PatchedSlideshow.prototype.constructor = PatchedSlideshow;

    PatchedSlideshow.prototype.destroy = function() {
      window.off('resize' + this.namespace);
      return originalDestroy.call(this);
    };

    theme.Slideshow = PatchedSlideshow;
    theme.__bsignSlideshowPatched = true;
  }

  function patchPrepareTransition() {
    if (!window.theme || !theme.utils || theme.utils.__bsignPrepareTransitionPatched) {
      return;
    }

    theme.utils.prepareTransition = function(el, callback) {
      if (!el) {
        return;
      }

      function removeClass() {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.addEventListener('transitionend', removeClass);
      el.classList.add('is-transitioning');

      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          if (typeof callback === 'function') {
            callback();
          }
        });
      });
    };

    theme.utils.__bsignPrepareTransitionPatched = true;
  }

  function patchPageTransitions() {
    if (!window.theme || typeof theme.pageTransitions !== 'function' || theme.__bsignPageTransitionsPatched) {
      return;
    }

    function shouldSkipTransition(anchor, event) {
      var href;
      var url;

      if (
        !anchor
        || event.defaultPrevented
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
        || (event.button && event.button !== 0)
      ) {
        return true;
      }

      href = anchor.getAttribute('href');

      if (
        !href
        || anchor.classList.contains('js-no-transition')
        || anchor.hasAttribute('download')
        || anchor.getAttribute('target') === '_blank'
        || href.charAt(0) === '#'
        || /^(mailto:|tel:|javascript:)/i.test(href)
        || href.indexOf('youtube.com/watch') > -1
        || href.indexOf('youtu.be/') > -1
      ) {
        return true;
      }

      try {
        url = new URL(anchor.href, window.location.href);
      } catch (error) {
        return true;
      }

      if (url.origin !== window.location.origin) {
        return true;
      }

      return Boolean(
        url.hash
        && url.pathname === window.location.pathname
        && url.search === window.location.search
      );
    }

    theme.pageTransitions = function() {
      if (!document.body || document.body.dataset.transitions !== 'true' || theme.__bsignPageTransitionsBound) {
        return;
      }

      theme.__bsignPageTransitionsBound = true;

      if (/Version\/[\d.]+.*Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS/i.test(navigator.userAgent)) {
        window.setTimeout(function() {
          document.body.classList.remove('unloading');
        }, 1200);
      }

      document.addEventListener('click', function(event) {
        var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        var src;

        if (shouldSkipTransition(anchor, event)) {
          return;
        }

        if (anchor.classList.contains('mobile-nav__link') && theme.NavDrawer && typeof theme.NavDrawer.close === 'function') {
          theme.NavDrawer.close();
        }

        event.preventDefault();
        document.body.classList.add('unloading');
        src = anchor.href;

        window.setTimeout(function() {
          window.location.href = src;
        }, 50);
      });
    };

    theme.__bsignPageTransitionsPatched = true;
  }

  function patchSectionsRegister() {
    if (!window.theme || !theme.Sections || theme.Sections.prototype.__bsignRegisterPatched) {
      return;
    }

    var originalRegister = theme.Sections.prototype.register;

    theme.Sections.prototype.register = function(type, constructor, container) {
      if (!container && this.constructors && this.constructors[type] === constructor) {
        return;
      }

      return originalRegister.call(this, type, constructor, container);
    };

    theme.Sections.prototype.__bsignRegisterPatched = true;
  }

  function patchQuickShopBinding() {
    if (!window.theme || typeof theme.initQuickShop !== 'function' || theme.__bsignQuickShopPatched) {
      return;
    }

    var quickShopPromises = {};
    var quickShopStylePromises = {};

    function normalizeStyleHref(href) {
      var anchor;

      if (!href) {
        return '';
      }

      anchor = document.createElement('a');
      anchor.href = href;

      return anchor.href;
    }

    function findExistingStylesheet(href) {
      var normalizedHref = normalizeStyleHref(href);
      var stylesheets = Array.prototype.slice.call(document.querySelectorAll('link[rel~="stylesheet"][href]'));

      return stylesheets.find(function(link) {
        return normalizeStyleHref(link.getAttribute('href')) === normalizedHref || link.href === normalizedHref;
      });
    }

    function waitForStylesheet(link) {
      if (link.sheet) {
        return Promise.resolve();
      }

      return new Promise(function(resolve) {
        var timeoutId;

        function finish() {
          window.clearTimeout(timeoutId);
          resolve();
        }

        link.addEventListener('load', finish, { once: true });
        link.addEventListener('error', finish, { once: true });

        timeoutId = window.setTimeout(finish, 3000);
      });
    }

    function loadQuickShopStyle(href) {
      var normalizedHref = normalizeStyleHref(href);
      var existingStylesheet;

      if (!normalizedHref) {
        return Promise.resolve();
      }

      existingStylesheet = findExistingStylesheet(normalizedHref);

      if (existingStylesheet) {
        if (existingStylesheet.media && existingStylesheet.media !== 'all') {
          existingStylesheet.media = 'all';
        }

        return waitForStylesheet(existingStylesheet);
      }

      if (quickShopStylePromises[normalizedHref]) {
        return quickShopStylePromises[normalizedHref];
      }

      quickShopStylePromises[normalizedHref] = new Promise(function(resolve) {
        var link = document.createElement('link');

        link.rel = 'stylesheet';
        link.href = normalizedHref;
        document.head.appendChild(link);

        waitForStylesheet(link).then(resolve);
      });

      return quickShopStylePromises[normalizedHref];
    }

    function collectQuickShopStyleHrefs(doc, productSection) {
      var seen = {};
      var hrefs = [];

      function addLink(link) {
        var href = normalizeStyleHref(link.getAttribute('href') || link.href);

        if (!href || seen[href]) {
          return;
        }

        seen[href] = true;
        hrefs.push(href);
      }

      doc.querySelectorAll('link[rel~="stylesheet"][href]').forEach(addLink);

      if (productSection) {
        productSection.querySelectorAll('link[rel~="stylesheet"][href]').forEach(function(link) {
          addLink(link);
          link.parentNode.removeChild(link);
        });
      }

      return hrefs;
    }

    function loadQuickShopStyles(doc, productSection) {
      var hrefs = collectQuickShopStyleHrefs(doc, productSection);

      if (!hrefs.length) {
        return Promise.resolve();
      }

      return Promise.all(hrefs.map(loadQuickShopStyle));
    }

    function isMobileQuickShop() {
      return window.innerWidth < 590 || Boolean(theme.config && theme.config.bpSmall);
    }

    function markQuickShopReady(btn) {
      if (!btn) {
        return;
      }

      btn.classList.remove('quick-product__btn--not-ready');
      btn.dataset.bsignQuickShopLoaded = 'true';
      btn.removeAttribute('aria-busy');
    }

    function preloadQuickShopModal(handle, productId, btn) {
      var key = productId || handle;
      var holder = document.getElementById('QuickShopHolder-' + handle);
      var url;

      if (!holder || !handle || !productId) {
        return Promise.resolve(false);
      }

      if (holder.querySelector('.product-section[data-product-handle="' + handle + '"]')) {
        markQuickShopReady(btn);
        return Promise.resolve(true);
      }

      if (quickShopPromises[key]) {
        return quickShopPromises[key];
      }

      if (btn) {
        btn.setAttribute('aria-busy', 'true');
      }

      url = theme.routes.home + '/products/' + handle + '?view=modal';
      url = url.replace('//', '/');

      quickShopPromises[key] = fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var productSection = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');
        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;

        if (!productSection) {
          throw new Error('Quick shop product section was not found for ' + handle);
        }

        return loadQuickShopStyles(doc, productSection).then(function() {
          holder.innerHTML = '';
          holder.append(productSection);

          new theme.Modals(modalId, name);
          theme.sections.register('product', theme.Product, holder);
          theme.collapsibles.init();
          theme.videoModal();

          markQuickShopReady(btn);

          return true;
        });
      }).catch(function(error) {
        if (btn) {
          btn.removeAttribute('aria-busy');
        }

        console.warn('[Bsign quick shop] Deferred modal load failed:', error && error.message ? error.message : error);
        return false;
      }).then(function(result) {
        delete quickShopPromises[key];
        return result;
      });

      return quickShopPromises[key];
    }

    theme.preloadProductModal = function(handle, productId, btn) {
      return preloadQuickShopModal(handle, productId, btn);
    };

    function bindMobileQuickShop(product, btn) {
      if (!product || !btn || btn.dataset.bsignMobileQuickShopBound === 'true') {
        return;
      }

      btn.dataset.bsignMobileQuickShopBound = 'true';

      btn.addEventListener('click', function(evt) {
        var productId;
        var handle;

        if (!isMobileQuickShop()) {
          return;
        }

        if (btn.dataset.bsignQuickShopLoaded === 'true' || !btn.classList.contains('quick-product__btn--not-ready')) {
          return;
        }

        evt.preventDefault();
        evt.stopImmediatePropagation();

        productId = product.dataset.productId;
        handle = product.dataset.productHandle;

        preloadQuickShopModal(handle, productId, btn).then(function(loaded) {
          if (!loaded) {
            return;
          }

          window.setTimeout(function() {
            btn.click();
          }, 0);
        });
      }, true);
    }

    theme.initQuickShop = function(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var products = Array.prototype.slice.call(root.querySelectorAll('.grid-product'));

      if (root.matches && root.matches('.grid-product')) {
        products.unshift(root);
      }

      if (!products.length || !theme.settings.quickView) {
        return;
      }

      products.forEach(function(product) {
        var btn;
        var productId;
        var handle;

        if (product.dataset.bsignQuickShopBound === 'true') {
          return;
        }

        btn = product.querySelector('.quick-product__btn');
        productId = product.dataset.productId;
        handle = product.dataset.productHandle;

        if (!btn || !productId || !handle) {
          return;
        }

        product.dataset.bsignQuickShopBound = 'true';
        bindMobileQuickShop(product, btn);

        product.addEventListener('mouseover', function productMouseover(evt) {
          var el = evt.currentTarget;
          var hoverProductId = el.dataset.productId;
          var hoverHandle = el.dataset.productHandle;
          var hoverBtn = el.querySelector('.quick-product__btn');

          if (theme.config.bpSmall) {
            return;
          }

          el.removeEventListener('mouseover', productMouseover);

          if (!el || !hoverProductId || !hoverHandle) {
            return;
          }

          theme.preloadProductModal(hoverHandle, hoverProductId, hoverBtn);
        });
      });
    };

    if (theme.settings && theme.settings.quickView) {
      document.querySelectorAll('.grid-product').forEach(function(product) {
        var btn = product.querySelector('.quick-product__btn');

        if (btn) {
          bindMobileQuickShop(product, btn);

          if (theme.sections) {
            product.dataset.bsignQuickShopBound = 'true';
          }
        }
      });
    }

    theme.__bsignQuickShopPatched = true;
  }

  function patchViewIn3dModal() {
    if (!window.theme || theme.__bsignViewIn3dModalPatched) {
      return;
    }

    theme.viewIn3dModal = function(holder) {
      if (!holder) {
        return;
      }

      var custom3dBtn = holder.querySelector('.custom-3d-btn');
      var closeButton = holder.querySelector('.custom-3d-btn--close');
      var modelContainer = holder.querySelector('.metafield-3d-model__container');
      var modelViewer = holder.querySelector('.metafield-3d-model__container model-viewer');
      var loader = holder.querySelector('.lds-ring');
      var arButton = holder.querySelector('#ar-button');

      if (custom3dBtn && modelContainer) {
        custom3dBtn.addEventListener('click', function() {
          modelContainer.classList.toggle('metafield-3d-model__container--active');
        });
      }

      if (closeButton && modelContainer) {
        closeButton.addEventListener('click', function() {
          modelContainer.classList.toggle('metafield-3d-model__container--active');
        });
      }

      if (modelViewer) {
        modelViewer.addEventListener('load', function() {
          var posterButton = modelViewer.shadowRoot
            && modelViewer.shadowRoot.querySelector('[part="default-poster"], #default-poster');

          if (posterButton) {
            posterButton.style.display = 'none';
          }

          if (loader) {
            loader.style.display = 'none';
          }

          if (arButton) {
            arButton.style.display = 'none';
          }
        });
      }

      if (arButton && modelViewer && typeof modelViewer.activateAR === 'function') {
        arButton.addEventListener('click', function() {
          modelViewer.activateAR();
        });
      }
    };

    theme.__bsignViewIn3dModalPatched = true;
  }

  function patchVideoLoading() {
    if (!window.theme || !theme.VideoSection || theme.__bsignVideoLoadingPatched) {
      return;
    }

    var videoState = {
      active: 0,
      queue: [],
      maxActive: 1,
      timeoutMs: 4000
    };

    function parseUrl(url) {
      if (!url) {
        return null;
      }

      try {
        return new URL(url, window.location.origin);
      } catch (error) {
        return null;
      }
    }

    function once(fn) {
      var called = false;

      return function() {
        if (called) {
          return;
        }

        called = true;
        fn.apply(this, arguments);
      };
    }

    function runNextVideoTask() {
      if (videoState.active >= videoState.maxActive || !videoState.queue.length) {
        return;
      }

      var nextTask = videoState.queue.shift();
      nextTask();
    }

    function releaseVideoTask(container) {
      if (!container || typeof container.__bsignVideoRelease !== 'function') {
        return;
      }

      var release = container.__bsignVideoRelease;
      container.__bsignVideoRelease = null;
      release();
    }

    function scheduleVideoTask(container, callback) {
      var task = function() {
        var released = false;
        var fallbackTimer;

        videoState.active += 1;

        container.__bsignVideoRelease = function() {
          if (released) {
            return;
          }

          released = true;
          container.__bsignVideoRelease = null;
          window.clearTimeout(fallbackTimer);
          videoState.active = Math.max(0, videoState.active - 1);
          runNextVideoTask();
        };

        fallbackTimer = window.setTimeout(function() {
          releaseVideoTask(container);
        }, videoState.timeoutMs);

        callback(container.__bsignVideoRelease);
      };

      if (videoState.active < videoState.maxActive) {
        task();
        return;
      }

      videoState.queue.push(task);
    }

    function isValidYoutubeId(videoId) {
      return /^[A-Za-z0-9_-]{6,}$/.test((videoId || '').trim());
    }

    function isValidVimeoId(videoId) {
      return /^[0-9]+$/.test((videoId || '').trim());
    }

    function isValidMp4Url(videoUrl) {
      var parsedUrl = parseUrl(videoUrl);

      return Boolean(
        parsedUrl &&
        /^https?:$/.test(parsedUrl.protocol) &&
        /\.mp4$/i.test(parsedUrl.pathname || '')
      );
    }

    function isShopifyVideoCdn(parsedUrl) {
      if (!parsedUrl || !parsedUrl.hostname) {
        return false;
      }

      var host = parsedUrl.hostname.toLowerCase();

      return host === 'cdn.shopify.com'
        || /(^|\.)shopifycdn\.com$/.test(host)
        || /(^|\.)shopifycdn\.net$/.test(host);
    }

    function setVideoDiagnostics(container, videoUrl) {
      var parsedUrl = parseUrl(videoUrl);
      var host = parsedUrl && parsedUrl.hostname ? parsedUrl.hostname.toLowerCase() : '';

      if (!container) {
        return parsedUrl;
      }

      if (host) {
        container.setAttribute('data-video-host', host);
      }

      if (parsedUrl) {
        container.setAttribute('data-video-cdn', isShopifyVideoCdn(parsedUrl) ? 'shopify' : 'external');
      }

      return parsedUrl;
    }

    function markVideoError(container, code, detail) {
      if (!container) {
        return;
      }

      container.classList.remove('loading');
      container.classList.add('loaded');
      container.setAttribute('data-video-error', code);

      if (detail) {
        container.setAttribute('data-video-error-detail', String(detail).slice(0, 180));
      }

      console.warn('[Bsign video]', code, detail || '', container);
    }

    function markExternalCdn(container, parsedUrl) {
      if (!container || !parsedUrl || isShopifyVideoCdn(parsedUrl)) {
        return;
      }

      console.warn('[Bsign video] External MP4 CDN detected:', parsedUrl.href);
    }

    function getVideoData(container) {
      return container ? container.querySelector('.video-div') : null;
    }

    function isMobileViewport() {
      return window.innerWidth < 590 || Boolean(theme.config && theme.config.bpSmall);
    }

    function getMp4VideoUrl(mp4Div) {
      return mp4Div
        ? (
          mp4Div.getAttribute('src')
          || mp4Div.getAttribute('data-src')
          || mp4Div.dataset.videoUrl
          || ''
        )
        : '';
    }

    function hydrateMp4Video(mp4Div, videoUrl) {
      if (!mp4Div || !videoUrl) {
        return false;
      }

      if (!mp4Div.getAttribute('src')) {
        mp4Div.setAttribute('src', videoUrl);
      }

      mp4Div.setAttribute('preload', 'none');
      mp4Div.dataset.videoHydrated = 'true';

      return true;
    }

    function deferMobileMp4Video(videoSection) {
      var mp4Video = 'Mp4Video-' + videoSection.sectionId;
      var mp4Div = document.getElementById(mp4Video);
      var parent = mp4Div ? mp4Div.closest('.video-parent-section') : null;
      var videoUrl = getMp4VideoUrl(mp4Div);
      var startVideo;

      if (!mp4Div || !parent) {
        return false;
      }

      if (!isValidMp4Url(videoUrl)) {
        markVideoError(parent, 'invalid-mp4-url', videoUrl);
        return true;
      }

      setVideoDiagnostics(parent, videoUrl);
      parent.classList.add('loaded');
      parent.classList.add('video-interactable');
      parent.setAttribute('data-video-mobile-deferred', 'true');
      mp4Div.setAttribute('preload', 'none');

      startVideo = once(function() {
        parent.removeAttribute('data-video-mobile-deferred');
        mp4Div.dataset.videoMobileActivated = 'true';
        videoSection.initMp4Video();
      });

      parent.addEventListener('pointerdown', startVideo, { once: true, passive: true });
      parent.addEventListener('click', startVideo, { once: true });

      return true;
    }

    if (theme.VideoSection.prototype && !theme.VideoSection.prototype.__bsignVideoPatched) {
      var videoSectionPrototype = theme.VideoSection.prototype;

      videoSectionPrototype.init = function() {
        var dataDiv = getVideoData(this.container);
        var type = dataDiv && dataDiv.dataset ? dataDiv.dataset.type : '';
        var videoId = dataDiv && dataDiv.dataset ? dataDiv.dataset.videoId : '';
        var self = this;

        if (!dataDiv || !type) {
          return;
        }

        if (type === 'youtube') {
          if (!isValidYoutubeId(videoId)) {
            markVideoError(this.container, 'invalid-youtube-id', videoId || dataDiv.dataset.videoUrl || '');
            return;
          }

          scheduleVideoTask(this.container, function() {
            self.initYoutubeVideo(videoId);
          });
          return;
        }

        if (type === 'vimeo') {
          if (!isValidVimeoId(videoId)) {
            markVideoError(this.container, 'invalid-vimeo-id', videoId || dataDiv.dataset.videoUrl || '');
            return;
          }

          scheduleVideoTask(this.container, function() {
            self.initVimeoVideo(videoId);
          });
          return;
        }

        if (type === 'mp4') {
          if (isMobileViewport() && deferMobileMp4Video(self)) {
            return;
          }

          self.initMp4Video();
        }
      };

      videoSectionPrototype.initMp4Video = function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div ? mp4Div.closest('.video-parent-section') : null;
        var videoUrl = getMp4VideoUrl(mp4Div);
        var parsedUrl = setVideoDiagnostics(parent, videoUrl);

        if (!mp4Div || !parent) {
          return;
        }

        if (isMobileViewport() && mp4Div.dataset.videoMobileActivated !== 'true') {
          deferMobileMp4Video(this);
          return;
        }

        if (!isValidMp4Url(videoUrl)) {
          markVideoError(parent, 'invalid-mp4-url', videoUrl);
          return;
        }

        markExternalCdn(parent, parsedUrl);

        scheduleVideoTask(parent, function(release) {
          var cleanup;
          var onReady;
          var onError;

          parent.classList.add('loading');
          parent.classList.remove('loaded');
          parent.removeAttribute('data-video-error');
          parent.removeAttribute('data-video-error-detail');

          cleanup = once(function() {
            mp4Div.removeEventListener('canplay', onReady);
            mp4Div.removeEventListener('loadeddata', onReady);
            mp4Div.removeEventListener('error', onError);
          });

          onReady = once(function() {
            cleanup();
            parent.classList.remove('loading');
            parent.classList.add('loaded');
            release();
          });

          onError = once(function() {
            cleanup();
            markVideoError(parent, 'mp4-load-error', videoUrl);
            release();
          });

          mp4Div.addEventListener('canplay', onReady, { once: true });
          mp4Div.addEventListener('loadeddata', onReady, { once: true });
          mp4Div.addEventListener('error', onError, { once: true });

          hydrateMp4Video(mp4Div, videoUrl);

          if (mp4Div.readyState >= 2) {
            onReady();
          }

          var playPromise = mp4Div.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {
              cleanup();
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
              markVideoError(parent, 'mp4-autoplay-blocked', videoUrl);
              release();
            });
          }
        });
      };

      videoSectionPrototype.__bsignVideoPatched = true;
    }

    if (theme.YouTube && theme.YouTube.prototype && !theme.YouTube.prototype.__bsignVideoPatched) {
      var youtubePrototype = theme.YouTube.prototype;
      var originalYoutubeInit = youtubePrototype.init;
      var originalYoutubeReady = youtubePrototype.onVideoPlayerReady;

      youtubePrototype.init = function() {
        if (!isValidYoutubeId(this.options && this.options.videoId)) {
          markVideoError(this.parent, 'invalid-youtube-id', this.options && this.options.videoId);
          releaseVideoTask(this.parent);
          return;
        }

        try {
          originalYoutubeInit.call(this);
        } catch (error) {
          markVideoError(this.parent, 'youtube-init-error', error && error.message);
          releaseVideoTask(this.parent);
        }
      };

      youtubePrototype.onVideoPlayerReady = function(evt) {
        if (typeof originalYoutubeReady === 'function') {
          originalYoutubeReady.call(this, evt);
        }

        releaseVideoTask(this.parent);
      };

      youtubePrototype.__bsignVideoPatched = true;
    }

    if (theme.VimeoPlayer && theme.VimeoPlayer.prototype && !theme.VimeoPlayer.prototype.__bsignVideoPatched) {
      var vimeoPrototype = theme.VimeoPlayer.prototype;
      var originalVimeoInit = vimeoPrototype.init;
      var originalVimeoReady = vimeoPrototype.playerReady;

      vimeoPrototype.init = function() {
        var self = this;

        if (!isValidVimeoId(this.videoId)) {
          markVideoError(this.parent, 'invalid-vimeo-id', this.videoId);
          releaseVideoTask(this.parent);
          return;
        }

        try {
          originalVimeoInit.call(this);

          if (this.videoPlayer && typeof this.videoPlayer.ready === 'function') {
            this.videoPlayer.ready().catch(function(error) {
              markVideoError(self.parent, 'vimeo-ready-error', error && error.message);
              releaseVideoTask(self.parent);
            });
          }
        } catch (error) {
          markVideoError(this.parent, 'vimeo-init-error', error && error.message);
          releaseVideoTask(this.parent);
        }
      };

      vimeoPrototype.playerReady = function() {
        if (typeof originalVimeoReady === 'function') {
          originalVimeoReady.call(this);
        }

        releaseVideoTask(this.parent);
      };

      vimeoPrototype.__bsignVideoPatched = true;
    }

    theme.__bsignVideoLoadingPatched = true;
  }

  function patchDeferredProductMp4() {
    if (!window.theme || window.__bsignDeferredProductMp4Patched) {
      return;
    }

    var selectors = {
      deferredInlineVideo: '.product__video[data-video-type="mp4"][data-deferred-video="true"]',
      deferredVideo: 'video[data-deferred-video="true"]',
      inlineTrigger: '.product-video-trigger--inline-mp4',
      modalTrigger: '.product-video-trigger--mp4',
      modalPlayer: '.product-video-mp4-sound',
      wrapper: '.product__video-wrapper',
      productSlide: '.product-main-slide'
    };
    var hasUserInteracted = false;
    var inlineObserver = null;
    var domObserver = null;

    function toArray(collection) {
      return Array.prototype.slice.call(collection || []);
    }

    function once(fn) {
      var called = false;

      return function() {
        if (called) {
          return;
        }

        called = true;
        fn.apply(this, arguments);
      };
    }

    function getWrapper(video) {
      return video ? video.closest(selectors.wrapper) : null;
    }

    function hasHiddenAncestor(element) {
      var current = element;

      while (current) {
        if (
          current.getAttribute('aria-hidden') === 'true' ||
          current.hasAttribute('hidden') ||
          current.hasAttribute('inert') ||
          current.classList.contains('hide') ||
          current.classList.contains('visually-invisible')
        ) {
          return true;
        }

        current = current.parentElement;
      }

      return false;
    }

    function getProductSlide(video) {
      return video ? video.closest(selectors.productSlide) : null;
    }

    function isActiveProductSlide(video) {
      var slide = getProductSlide(video);
      var selectedSlide;

      if (!slide) {
        return true;
      }

      if (hasHiddenAncestor(slide)) {
        return false;
      }

      if (slide.classList.contains('is-selected')) {
        return true;
      }

      selectedSlide = slide.parentNode && slide.parentNode.querySelector
        ? slide.parentNode.querySelector(selectors.productSlide + '.is-selected')
        : null;

      return !selectedSlide && slide.classList.contains('starting-slide');
    }

    function isElementInViewport(element) {
      var rect;
      var viewportWidth;
      var viewportHeight;
      var horizontalOverlap;
      var verticalOverlap;
      var minimumHorizontalOverlap;

      if (!element || typeof element.getBoundingClientRect !== 'function') {
        return false;
      }

      if (hasHiddenAncestor(element)) {
        return false;
      }

      rect = element.getBoundingClientRect();
      viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      if (!viewportWidth || !viewportHeight || rect.width <= 0 || rect.height <= 0) {
        return false;
      }

      horizontalOverlap = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
      verticalOverlap = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      minimumHorizontalOverlap = Math.max(Math.min(rect.width * 0.25, 80), 24);

      return horizontalOverlap >= minimumHorizontalOverlap && verticalOverlap > 0;
    }

    function shouldPrepareInlineVideo(video) {
      if (!video) {
        return false;
      }

      if (!isElementInViewport(video)) {
        return false;
      }

      return isActiveProductSlide(video);
    }

    function hydrateVideoSources(video) {
      var didHydrate = false;

      if (!video) {
        return didHydrate;
      }

      toArray(video.querySelectorAll('source[data-src]')).forEach(function(source) {
        var sourceUrl = source.getAttribute('data-src');

        if (!sourceUrl) {
          return;
        }

        source.setAttribute('src', sourceUrl);
        source.removeAttribute('data-src');
        didHydrate = true;
      });

      if (didHydrate || !video.querySelector('source[data-src]')) {
        video.dataset.videoHydrated = 'true';
      }

      return didHydrate;
    }

    function prepareVideo(video, options) {
      var settings = options || {};
      var wrapper = getWrapper(video);
      var onReady;
      var onError;

      if (!video) {
        return false;
      }

      hydrateVideoSources(video);

      if (settings.load === false || video.dataset.videoPrepared === 'true') {
        return true;
      }

      if (wrapper) {
        wrapper.classList.add('video-loading');
      }

      onReady = once(function() {
        if (wrapper) {
          wrapper.classList.remove('video-loading');
          wrapper.classList.add('loaded');
        }
      });

      onError = once(function() {
        if (wrapper) {
          wrapper.classList.remove('video-loading');
        }
      });

      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('error', onError, { once: true });

      video.setAttribute('preload', 'none');

      try {
        video.load();
        video.dataset.videoPrepared = 'true';
      } catch (error) {
        onError();
      }

      if (video.readyState >= 2) {
        onReady();
      }

      return true;
    }

    function playVideo(video) {
      var wrapper = getWrapper(video);
      var playPromise;

      if (!video) {
        return;
      }

      prepareVideo(video);
      video.dataset.videoActivated = 'true';
      video.setAttribute('controls', '');

      if (wrapper) {
        wrapper.classList.add('video-started');
        wrapper.classList.add('video-interactable');
        wrapper.setAttribute('data-video-style', 'unmuted');
      }

      playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          if (wrapper) {
            wrapper.classList.add('video-interactable');
          }
        });
      }
    }

    function maybePrepareVisibleInlineVideos(scope) {
      toArray((scope || document).querySelectorAll(selectors.deferredInlineVideo)).forEach(function(video) {
        if (video.dataset.videoPrepared === 'true' || video.dataset.videoActivated === 'true') {
          return;
        }

        if (shouldPrepareInlineVideo(video)) {
          prepareVideo(video);
        }
      });
    }

    function markUserInteraction() {
      if (hasUserInteracted) {
        return;
      }

      hasUserInteracted = true;
      maybePrepareVisibleInlineVideos(document);
    }

    function registerInlineVideo(video) {
      if (!video || video.dataset.deferredVideoRegistered === 'true') {
        return;
      }

      video.dataset.deferredVideoRegistered = 'true';

      video.addEventListener('play', function() {
        var wrapper = getWrapper(video);

        if (!wrapper) {
          return;
        }

        wrapper.classList.add('video-started');
        wrapper.classList.remove('video-loading');
      });

      video.addEventListener('pause', function() {
        var wrapper = getWrapper(video);

        if (!wrapper || video.ended) {
          return;
        }

        wrapper.classList.add('video-interactable');
      });

      if (inlineObserver) {
        inlineObserver.observe(video);
      }
    }

    function scanInlineVideos(scope) {
      toArray((scope || document).querySelectorAll(selectors.deferredInlineVideo)).forEach(registerInlineVideo);
    }

    if ('IntersectionObserver' in window) {
      inlineObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting || !hasUserInteracted || !shouldPrepareInlineVideo(entry.target)) {
            return;
          }

          prepareVideo(entry.target);
        });
      }, {
        rootMargin: '200px 0px'
      });
    }

    if (window.theme && theme.Product && theme.Product.prototype && !theme.Product.prototype.__bsignDeferredMp4Patched) {
      var productPrototype = theme.Product.prototype;
      var originalPlayMp4Video = productPrototype.playMp4Video;

      productPrototype.playMp4Video = function(id) {
        var player = this.container ? this.container.querySelector('#' + id) : null;

        if (!player || player.dataset.deferredVideo !== 'true') {
          return originalPlayMp4Video.apply(this, arguments);
        }

        if (player.dataset.videoActivated === 'true') {
          prepareVideo(player);
          return originalPlayMp4Video.apply(this, arguments);
        }

        if (hasUserInteracted && shouldPrepareInlineVideo(player)) {
          prepareVideo(player);
        }

        return undefined;
      };

      theme.Product.prototype.__bsignDeferredMp4Patched = true;
    }

    document.addEventListener('click', function(event) {
      var modalTrigger = event.target.closest(selectors.modalTrigger);
      var inlineTrigger = event.target.closest(selectors.inlineTrigger);
      var hiddenPlayer;
      var videoId;
      var inlineVideo;

      if (modalTrigger) {
        markUserInteraction();
        hiddenPlayer = modalTrigger.parentNode ? modalTrigger.parentNode.querySelector(selectors.modalPlayer) : null;

        if (hiddenPlayer) {
          hydrateVideoSources(hiddenPlayer);
        }
      }

      if (!inlineTrigger) {
        return;
      }

      event.preventDefault();
      markUserInteraction();

      videoId = inlineTrigger.getAttribute('aria-controls');
      inlineVideo = videoId ? document.getElementById(videoId) : inlineTrigger.parentNode.querySelector(selectors.deferredVideo);

      playVideo(inlineVideo);
    }, true);

    document.addEventListener('pointerdown', markUserInteraction, { once: true, passive: true });
    document.addEventListener('touchstart', markUserInteraction, { once: true, passive: true });
    document.addEventListener('keydown', markUserInteraction, { once: true });
    window.addEventListener('scroll', markUserInteraction, { once: true, passive: true });

    scanInlineVideos(document);

    if ('MutationObserver' in window) {
      domObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          toArray(mutation.addedNodes).forEach(function(node) {
            if (!node || node.nodeType !== 1) {
              return;
            }

            if (node.matches && node.matches(selectors.deferredInlineVideo)) {
              registerInlineVideo(node);
              return;
            }

            if (node.querySelectorAll) {
              scanInlineVideos(node);
            }
          });
        });
      });

      domObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    window.__bsignDeferredProductMp4Patched = true;
  }

  function patchCollectionMp4StartGuard() {
    if (!document.body || window.__bsignCollectionMp4StartGuardPatched) {
      return;
    }

    if (!document.body.classList.contains('template-collection')) {
      return;
    }

    if (window.innerWidth >= 590 && !(window.theme && theme.config && theme.config.bpSmall)) {
      return;
    }

    function toArray(collection) {
      return Array.prototype.slice.call(collection || []);
    }

    function isMp4Url(url) {
      return /\.mp4(?:[?#].*)?$/i.test(url || '');
    }

    function getSourceUrl(source) {
      return source.getAttribute('src') || source.getAttribute('data-src') || '';
    }

    function hasMp4Source(video) {
      if (isMp4Url(video.getAttribute('src'))) {
        return true;
      }

      return toArray(video.querySelectorAll('source')).some(function(source) {
        return isMp4Url(getSourceUrl(source));
      });
    }

    function deferSource(source) {
      var sourceUrl = source.getAttribute('src');

      if (!sourceUrl || source.getAttribute('data-src')) {
        return;
      }

      source.setAttribute('data-src', sourceUrl);
      source.removeAttribute('src');
    }

    function hydrateVideo(video) {
      var videoSrc = video.getAttribute('data-src');

      if (video.dataset.bsignCollectionMp4Hydrated === 'true') {
        return;
      }

      if (videoSrc) {
        video.setAttribute('src', videoSrc);
        video.removeAttribute('data-src');
      }

      toArray(video.querySelectorAll('source[data-src]')).forEach(function(source) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      });

      video.dataset.bsignCollectionMp4Hydrated = 'true';
    }

    function guardVideo(video) {
      var videoSrc;

      if (
        !video
        || video.dataset.bsignCollectionMp4Guarded === 'true'
        || video.dataset.deferredVideo === 'true'
        || video.closest('.video-parent-section')
        || video.closest('#VideoModal')
        || !hasMp4Source(video)
      ) {
        return;
      }

      video.dataset.bsignCollectionMp4Guarded = 'true';
      video.setAttribute('preload', 'none');
      video.removeAttribute('autoplay');
      video.autoplay = false;

      videoSrc = video.getAttribute('src');
      if (videoSrc) {
        video.setAttribute('data-src', videoSrc);
        video.removeAttribute('src');
      }

      toArray(video.querySelectorAll('source')).forEach(deferSource);

      try {
        video.pause();
        video.load();
      } catch (error) {
        // Ignore unsupported third-party media states.
      }

      video.addEventListener('pointerdown', function() {
        hydrateVideo(video);
      }, { once: true, passive: true });

      video.addEventListener('click', function() {
        var playPromise;

        hydrateVideo(video);

        if (typeof video.play !== 'function') {
          return;
        }

        playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      }, { once: true });
    }

    function scanVideos(root) {
      toArray((root || document).querySelectorAll('video')).forEach(guardVideo);
    }

    scanVideos(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          toArray(mutation.addedNodes).forEach(function(node) {
            if (!node || node.nodeType !== 1) {
              return;
            }

            if (node.matches && node.matches('video')) {
              guardVideo(node);
              return;
            }

            if (node.querySelectorAll) {
              scanVideos(node);
            }
          });
        });
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    window.__bsignCollectionMp4StartGuardPatched = true;
  }

  function patchStickyHeaderWrapHeight() {
    if (!document.body || window.__bsignStickyHeaderWrapPatched) {
      return;
    }

    var wrapper = document.getElementById('StickyHeaderWrap');
    var headerWrapper = document.getElementById('HeaderWrapper');
    var siteHeader = document.getElementById('SiteHeader');
    var observer = null;
    var isUpdating = false;

    function toArray(collection) {
      return Array.prototype.slice.call(collection || []);
    }

    function px(value) {
      return value + 'px';
    }

    function getVisibleFlowHeight(element) {
      var rect;
      var style;

      if (!element || typeof element.getBoundingClientRect !== 'function') {
        return 0;
      }

      style = window.getComputedStyle(element);

      if (
        style.display === 'none'
        || style.visibility === 'hidden'
        || style.position === 'absolute'
        || style.position === 'fixed'
      ) {
        return 0;
      }

      rect = element.getBoundingClientRect();

      return Math.max(0, rect.height);
    }

    function getHeaderChromeHeight() {
      var directChildrenHeight;
      var measuredHeight;
      var maxReasonableHeight = window.innerWidth < 590 ? 180 : 240;

      if (!siteHeader) {
        return 0;
      }

      directChildrenHeight = toArray(siteHeader.children).reduce(function(total, child) {
        if (child.id === 'HeaderSearchDrawer') {
          return total;
        }

        return total + getVisibleFlowHeight(child);
      }, 0);

      measuredHeight = Math.ceil(directChildrenHeight || siteHeader.getBoundingClientRect().height || siteHeader.offsetHeight || 0);

      if (!measuredHeight) {
        return 0;
      }

      return Math.min(measuredHeight, maxReasonableHeight);
    }

    function setOverlayPointerGuard() {
      if (!headerWrapper || !headerWrapper.classList.contains('header-wrapper--overlay')) {
        return;
      }

      headerWrapper.style.pointerEvents = 'none';

      if (wrapper) {
        wrapper.style.pointerEvents = 'none';
      }

      if (siteHeader) {
        siteHeader.style.pointerEvents = 'auto';
      }
    }

    function normalizeHeight() {
      var headerHeight;
      var currentHeight;
      var nextHeight;

      wrapper = document.getElementById('StickyHeaderWrap');
      headerWrapper = document.getElementById('HeaderWrapper');
      siteHeader = document.getElementById('SiteHeader');

      if (!wrapper || !siteHeader) {
        return;
      }

      setOverlayPointerGuard();

      headerHeight = getHeaderChromeHeight();

      if (!headerHeight) {
        return;
      }

      currentHeight = parseFloat(wrapper.style.height || wrapper.getBoundingClientRect().height || 0);
      nextHeight = px(headerHeight);

      if (Math.abs(currentHeight - headerHeight) < 1) {
        return;
      }

      isUpdating = true;
      wrapper.style.height = nextHeight;
      window.requestAnimationFrame(function() {
        isUpdating = false;
      });
    }

    function scheduleNormalize() {
      window.requestAnimationFrame(normalizeHeight);
    }

    normalizeHeight();
    window.addEventListener('load', scheduleNormalize, { passive: true });
    window.addEventListener('resize', scheduleNormalize, { passive: true });
    document.addEventListener('page:loaded', scheduleNormalize);

    if ('MutationObserver' in window && wrapper) {
      observer = new MutationObserver(function(mutations) {
        if (isUpdating) {
          return;
        }

        if (mutations.some(function(mutation) {
          return mutation.type === 'attributes' && mutation.attributeName === 'style';
        })) {
          scheduleNormalize();
        }
      });

      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    window.__bsignStickyHeaderWrapPatched = {
      normalize: normalizeHeight,
      observer: observer
    };
  }

  function patchStickyHeaderFooterCollision() {
    if (!document.body || window.__bsignStickyHeaderFooterCollisionPatched) {
      return;
    }

    var siteHeader = null;
    var footer = null;
    var ticking = false;
    var hiddenClass = 'site-header--footer-hidden';

    function refreshElements() {
      siteHeader = document.getElementById('SiteHeader');
      footer = document.querySelector('.site-footer');
      scheduleUpdate();
    }

    function setHidden(hidden) {
      if (!siteHeader || siteHeader.classList.contains(hiddenClass) === hidden) {
        return;
      }

      siteHeader.classList.toggle(hiddenClass, hidden);
      siteHeader.inert = hidden;
    }

    function update() {
      var footerRect;
      var headerHeight;
      var shouldHide;

      ticking = false;

      if (!siteHeader || !footer || !document.documentElement.contains(siteHeader) || !document.documentElement.contains(footer)) {
        siteHeader = document.getElementById('SiteHeader');
        footer = document.querySelector('.site-footer');

        if (!siteHeader || !footer) {
          return;
        }
      }

      if (!siteHeader.classList.contains('site-header--stuck')) {
        setHidden(false);
        return;
      }

      footerRect = footer.getBoundingClientRect();
      headerHeight = siteHeader.getBoundingClientRect().height;
      shouldHide = footerRect.top <= headerHeight && footerRect.bottom > 0;

      setHidden(shouldHide);
    }

    function scheduleUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(update);
    }

    refreshElements();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', refreshElements, { passive: true });
    document.addEventListener('page:loaded', refreshElements);
    document.addEventListener('shopify:section:load', refreshElements);

    window.__bsignStickyHeaderFooterCollisionPatched = {
      refresh: refreshElements,
      update: scheduleUpdate
    };
  }

  patchEventUtilities();
  patchParallax();
  patchSlideshowResizeCleanup();
  patchPrepareTransition();
  patchPageTransitions();
  patchSectionsRegister();
  patchQuickShopBinding();
  patchViewIn3dModal();
  patchVideoLoading();
  patchDeferredProductMp4();
  patchCollectionMp4StartGuard();
  patchStickyHeaderWrapHeight();
  patchStickyHeaderFooterCollision();
})();
